import React, { useEffect } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { GradeLevelsSection } from './components/GradeLevelsSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    document.title = 'THE COMPLETE ART YEAR™';
  }, []);
  return <div className="w-full bg-navy text-white" data-id="element-0" data-mp="3rcsulke91w9o">
      <MetaPixel data-id="element-1" data-mp="5opiv1o0k3w" />
      <StickyHeader data-id="element-2" data-mp="682dxcgkib2" />
      <main data-id="element-3" data-mp="5gel8p3rovc">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="56l3b4umzkw" />
        <Hero data-id="element-5" data-mp="2zlv66six0xu0" />
        <SocialProofBar data-id="element-6" data-mp="2zm4v0cs84yy4" />
        <PainSection data-id="element-7" data-mp="2zmwggus3xgao" />
        <ProductIntro data-id="element-8" data-mp="2znfy0adui2o6" />
        <VolumesSection data-id="element-9" data-mp="33m5cy7ej7s9x" />
        <BonusesSection data-id="element-10" data-mp="33ngf62sbwryx" />
        <ValueStack data-id="element-11" data-mp="33myix65o2dr0" />
        <GradeLevelsSection data-id="element-12" data-mp="38lrp0dimj2h5" />
        <Testimonials data-id="element-13" data-mp="38li8rhnds9on" />
        <HowItWorks data-id="element-14" data-mp="38l06a3a4kz8a" />
        <Guarantee data-id="element-15" data-mp="38nuorp9kw9z2" />
        <ClosingBlock data-id="element-16" data-mp="3dkuufz2inapn" />
        <FAQ data-id="element-17" data-mp="3dle3sre3oqs2" />
      </main>
      <Footer data-id="element-18" data-mp="3dlns8ajhypvn" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-19" data-mp="3dm5xtxs1ugg8" />
      {showPurchaseNotifications && <SocialProofPopup data-id="element-20" data-mp="nv0wrpdfmi3k" />}
      <FloatingCTA data-id="element-21" data-mp="nxwvvh10nctl" />
    </div>;
}